import config from "../config/GraphViewConfig";

const graph = {
    adj: {},
    buttonNodeMapping: {},
    createAdjacencyList(nodes = [], edges = []) {
        const adj = {}

        this.createButtonNodeMapping(nodes) // need mapping because edges are button -> node

        edges.forEach(edge => {
            const connectingNodeId = this.buttonNodeMapping[edge.buttonId]

            if (!connectingNodeId) return

            if (!(connectingNodeId in adj)) {
                adj[connectingNodeId] = [edge.questionId]
                return
            }

            if (adj[connectingNodeId].some(nodeId => nodeId === edge.questionId)) return;

            adj[connectingNodeId].push(edge.questionId);

        })

        nodes.forEach(node => {
            if (!(node.id in adj)) {
                adj[node.id] = []
            }
        })

        this.adj = adj
    },
    createButtonNodeMapping(nodes) {
        if (!nodes.length) return {}

        const isNodeData = !!nodes[0].buttons // for handling both node and nodeData

        const mapping = {}

        nodes.forEach(node => {
            const buttons = isNodeData ? node.buttons : node.data.buttons
            if (buttons) {
                buttons.forEach(button => {
                    mapping[button.id] = node.id
                })
            }
        })

        this.buttonNodeMapping = mapping
    }
}

export {graph}


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/services/GraphService.js